<template>
  <div class="page final result">
    <main>
      <div class="citybg"></div>
      <div class="ornamentline"></div>
      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final">
            Ja,
            <br />ik wil kinderen.
          </h2>
          <p class="bodyslide--final">
            Je wil dus op {{ age }} beginnen aan kinderen en je wilt graag
            {{ kinderen }} kinderen.
            <br />
            <br />De meeste koppels kunnen nog perfect zwanger worden rond hun 30ste. Als je echter daarna nog graag een 2de of een 3de kind wilt, dan is de kans groot dat jullie al een eindje in de 30 zijn voor de 2de, 3de, … zwangerschap.
          </p>
        </div>
        <div class="babylyingcontainer">
          <img src="./../assets/img/babylying.svg" class="babylying" />
        </div>
      </header>
      <section class="infosection" id="facts">
        <div class="leftblok">
          <header>
            <h3 class="sectiontitle">Wist je dat?</h3>
            <p
              class="sectionintro"
            >Sommige koppels moeten het ideaal aantal kinderen jammer genoeg bijstellen door het dalen van de vruchtbaarheid op die leeftijd.</p>
          </header>
          <div class="articleblocks">
            <article>
              <h4 class="articletitle">De magische grens van 30 jaar</h4>
              <p class="articlebody">
                Is jouw
                <strong>(vrouwelijke) partner</strong> jonger of ouder? Bekijk
                <router-link to="/extrainfo#houdbaarheidsdatum">hier</router-link>&nbsp; dan eens de informatie rond het effect van leeftijd op vruchtbaarheid. Vanaf hun 30ste begint de vruchtbaarheid bij vrouwen te dalen (deze daling zet zich al lichtjes in vanaf de leeftijd van 25 jaar) en neemt gestaag af in de komende jaren.
              </p>
            </article>
            <article>
              <h4 class="articletitle">Wat met IVF?</h4>
              <p class="articlebody">
                Ook als je gebruik maakt van IVF of medisch begeleide voortplanting, speelt de
                <strong>leeftijd van de vrouw</strong>
                een rol in de slaagkansen. Na hun 30ste hebben vrouwen ook al een iets verhoogde kans op een miskraam.
              </p>
            </article>
          </div>
          <div class="articleblocks">
            <article>
              <p class="articlebody">
                <br />Voor sommige vrouwen kan het invriezen van eicellen een
                oplossing zijn. Klik
                <router-link to="/extrainfo#eicelleninvriezen">hier</router-link>&nbsp; voor meer informatie.
                <br />
                <br />Zowel bij mannen als bij vrouwen kunnen een aantal
                aandoeningen er voor zorgen dat zwanger worden niet onmiddellijk
                lukt. Een gezonde leefstijl is voor beide partners belangrijk om
                de kans op een zwangerschap te verhogen.
                <br />
                <br />Meer informatie rond de
                impact van leefstijl op de vruchtbaarheid vind je
                <a
                  href="https://www.deverdwaaldeooievaar.be/vruchtbaarheidproblemen/levensstijl"
                >hier</a>
                en
                <a
                  href="https://www.gezondzwangerworden.be/zwanger-worden/leefstijlfactoren-die-de-vruchtbaarheid-be%C3%AFnvloeden"
                >hier</a>.
              </p>
              <p>
                <levensweg-button
                  class="nextButtonresults"
                  label="Bijkomende info"
                  color="blue right"
                  link="extrainfo"
                />
              </p>
            </article>
          </div>
        </div>
        <div class="rightblok">
          <aside class="parentsaside">
            <img src="./../assets/img/parents.svg" class="parents" />
          </aside>
          <div class="rightblock__line" />
        </div>
      </section>

      <levensweg-footer class="footer" />
    </main>
  </div>
</template>

<script>
import Footer from "./../components/Footer";
import Header from "./../components/Header";
import Levenswegbutton from "./../components/Levenswegbutton";

export default {
  components: {
    "levensweg-footer": Footer,
    "levensweg-header": Header,
    "levensweg-button": Levenswegbutton
  },
  computed: {
    age() {
      let compAge =
        18 +
        this.$store.state.verderstuderen +
        this.$store.state.activiteitentijd;
      return compAge;
    },
    kinderen() {
      return this.$store.state.aantalkindereren;
    }
  }
};
</script>

<style>
.result .nextButtonresults a:link,
.result .nextButtonresults a:visited,
.result .nextButtonresults a:link:active,
.result .nextButtonresults a:visited:active {
  color: white;
  margin-left: 0;
}

.nextButtonresults {
  margin-top: 3rem;
  margin-bottom: 3rem;
  text-align: center;
}
.result a:link,
.result a:visited,
.result a:link:active,
.result a:visited:active {
  color: var(--blue);
}

.articlebody strong {
  font-weight: bold;
}
.footer {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}

.planningtop {
  margin-top: 2.2rem;
}

.rightblok {
  display: flex;
  flex-direction: column;

  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left: -1.8rem;
  margin-right: -1.8rem;
}
.parentsaside {
  align-self: center;
}
.rightblock__line {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}
.rightblock__line__flipped {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_ivf.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 259px;
  height: 402px;
  z-index: -1;
  margin-top: -7rem;
}
.rightblok:after {
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 100%;
  height: 368px;
  margin-top: -3rem;
}
.rightblok.ivfblok:after {
  margin-top: 2rem;
}

.parents {
  width: 232px;
  height: 319px;
}
.ivf {
  width: 342px;
  height: 324px;
}

.babylyingcontainer {
  /*margin-left: calc(-26.13% * 2);*/
  margin-top: 4rem;
  margin-bottom: 8rem;
  z-index: -2;
}
.babylying {
  height: auto;
  width: 100%;
}
/*
.babylying {
  width: auto;
  height: 291px;
  object-fit: cover;
}*/
.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
}
.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
}

.header--final {
  display: flex;
  flex-direction: column;
}
.infosection {
  display: flex;
  flex-direction: column;
}
.articleblocks {
  display: flex;
  flex-direction: column;
}
.infosection,
.testimonialsection {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
}

.sectiontitle {
  font-family: Montserrat;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2rem;
  color: var(--orange);
}

.sectionintro {
  font-family: "Playfair Display";
  font-size: 2rem;
  color: var(--titleslidecolor);
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.articletitle {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.articletitle.second {
  margin-top: 3rem;
}

.articlebody {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--articlebodycolor);
  margin-right: 4.4rem;
}
.articlebody.noheading {
  margin-top: 3rem;
}

.titleslide--final {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);

  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide--final {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 0 0 0;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}
.btn--final a {
  margin-left: 0;
}

.header--final {
  margin: 14.4rem 14.6% 0 14.6%;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
  }

  .babylyingcontainer {
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
  }
  .babylying {
    width: 80%;
    max-width: 457px;
    height: 80%;
    max-height: 374px;
  }
  .infosection {
    flex-direction: row;
    align-items: flex-end;
  }
  .header--final {
    flex-direction: row-reverse;
    margin-left: 1.8rem;
    margin-right: 1.8rem;
    align-items: flex-end;
    margin-bottom: 8rem;
  }
  .header--final div {
    flex: 50%;
  }

  .sectionintro {
    width: 75%;
  }
  .rightblok:after {
    display: none;
  }
  .infosection:after {
    content: "";
    position: absolute;
    z-index: -2;
    background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
    background-position-x: right;
    width: 80%;
    height: 80%;
    margin-top: 3rem;
    right: 0;
  }
  .infosection.plan:after {
    content: "";
    position: absolute;
    z-index: -2;
    background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
    background-position-x: right;
    width: 80%;
    height: 80%;
    margin-top: 3rem;
    left: 0;
    transform: rotate(180deg);
  }
  .rightblock__line__flipped {
    align-self: flex-start;
  }
  .parentsaside {
    align-self: flex-start;
  }
  .titleslide--final {
    width: 100%;
    max-width: 400px;
  }
}

@media only screen and (min-width: 992px) {
  #facts .articlebody {
    width: 75%;
  }

  .header--final {
    flex-direction: row-reverse;
  }
  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection {
    flex-direction: row;
    align-items: flex-start;
  }
  .infosection.plan {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .articleblocks {
    flex-direction: row;
  }

  .articleblocks article {
    flex: 50%;
  }
  .planningtop .articlebody {
    width: 50%;
  }

  .sectionintro {
    width: 70%;
  }
  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}
@media only screen and (min-width: 1200px) {
  .titleslide--final {
    font-size: 8rem;
    line-height: 1.06;
  }
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .babylyingcontainer {
    margin-right: 123px;
  }
  .header--final {
    margin-top: 81px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final {
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle {
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro {
    font-size: 3rem;
  }
  .articletitle {
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second {
    margin-top: 7.5rem;
  }
  .articlebody {
    font-size: 1.5rem;
  }
  .plan .articlebody {
    width: 40.9rem;
  }
  .page.final {
    height: auto;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .btn--final {
    margin-top: 4rem;
  }
}
</style>
